


































































































































































import {Component} from 'vue-property-decorator'
import axios from 'axios'
import { apiV1AdminUserPath, apiV1AdminUserResendConfirmationPath, apiV1AdminUserTopicsPath } from '@/rails/routes'
import User, {IUser} from '@/models/User'
import TopicThread from '@/components/admin/topics/Thread.vue'
import Topic, {ITopic} from '@/models/Topic'
import PageBase, {BreadCrumb} from '@/pages/page-base'
import ApplicantList from '@/components/admin/applicants/List.vue'

@Component({
  components: {
    TopicThread,
    ApplicantList
  }
})
export default class UserTopics extends PageBase {
  showedEditThread = false
  user = new User()
  panels: Array<number> = []
  editTopic = new Topic()

  async mounted(): Promise<void> {
    try {
      super.mounted()
      await this.reload()
      this.panels = this.user.topics.map((_t, i) => i)
      this.loading = false
    } catch (e) {
      console.error(e)
    }
  }

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: '登録者管理一覧',
        to: '/admin/users',
        exact: true
      },
      {
        text: '登録者管理詳細',
      },
    ]
  }

  async reload(): Promise<void> {
    const res = await axios.get<IUser>(apiV1AdminUserPath(this.$route.params.id))
    this.user = new User(res.data)
    const resTopics = await axios.get<Array<ITopic>>(apiV1AdminUserTopicsPath(this.$route.params.id))
    this.user.topics = resTopics.data.map(t => new Topic(t))
  }

  async deleteUser(): Promise<void> {
    this.showConfirm({
      message: 'ユーザーを退会済にします、よろしいですか？',
      onClosed: async (result) => {
        if (!result) {
          return
        }

        try {
          const res = await axios.delete(apiV1AdminUserPath(this.$route.params.id))
          this.user = new User(res.data)
          this.showMessage('ユーザーを退会済にしました')
        } catch (e) {
          console.log(e)
        }
      }
    })
  }

  async resendConfirm(): Promise<void> {
    this.showConfirm({
      message: '登録メールを再送します、よろしいですか？',
      onClosed: async (result) => {
        if (!result) {
          return
        }

        try {
          await axios.post(apiV1AdminUserResendConfirmationPath(this.$route.params.id))
          this.showMessage('登録メールを再送しました')
        } catch (e) {
          console.log(e)
        }
      }
    })
  }

  async saveTopic(): Promise<void> {
    if(!this.editTopic.title || !this.editTopic.description) {
      this.showError('タイトル・内容を入力してください')
      return
    }
    try {
      await axios.post(apiV1AdminUserTopicsPath(this.$route.params.id), {
        topic: this.editTopic.toParams()
      })
      this.showMessage('変更を保存しました。')
      this.showedEditThread = false
      this.reload()
    } catch (e) {
      console.log(e)
    }
  }
}
